import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { figures } from "@/mocks/news";

export default function FiguresSection() {
  return (
    <section id="figures" className="border-y border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div className="w-full">
              <span className="label-font text-xs uppercase tracking-[0.24em] text-primary-600">
                Focus Figures
              </span>
              <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
                热门人物追踪
              </h2>
              <p className="mt-2.5 max-w-2xl text-sm leading-relaxed text-foreground-600">
                按本周被追踪的频次排序，每位只记录公开行程与合作变化，不涉及任何未公开的个人信息。
              </p>
            </div>
            <Link
              to="/category/figures"
              className="inline-flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              全部人物动态
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {figures.map((figure, index) => (
            <Reveal key={figure.name} delay={Math.min(index, 5) * 60}>
              <div className="card-lift flex h-full items-center gap-4 rounded-lg border border-background-200 bg-background-100/70 p-4">
                <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md md:h-20 md:w-20">
                  <img
                    src={figure.avatar}
                    alt={`${figure.name} 人物动态速递配图`}
                    title={`${figure.name} · 料闻社追踪`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-baseline gap-2">
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {figure.name}
                    </h3>
                    <span className="text-xs text-foreground-500">{figure.role}</span>
                  </div>
                  <p className="mt-1.5 truncate text-sm text-foreground-600">
                    追踪焦点：{figure.focus}
                  </p>
                  <div className="mt-2.5 flex items-center gap-2">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-primary-500"
                        style={{ width: `${figure.heat}%` }}
                      />
                    </div>
                    <span className="label-font text-xs font-semibold text-primary-600">
                      {figure.heat}
                    </span>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}